module.exports = __webpack_public_path__ + "img/parent2.cebde175.png";